import { MapperBase } from '../../utilities/mapper-base';
import { FileTypeResource } from '../resource/file-type.resource';
import { FileType } from '../ui/file.model';
import { FileTypeToFileTypeResourceMap } from './maps/file-type-to-file-type-resource.map';

export class FileTypeResourceToFileTypeMapper extends MapperBase<FileTypeResource, FileType> {
	map(source: FileTypeResource): FileType {
		return [...FileTypeToFileTypeResourceMap.entries()].find((item) => item[1] === source)?.[0];
	}
}


